import { Module } from 'vuex'

import { GetJudgeCaseListUseCase } from '@/application/testCase/getJudgeCaseListUseCase'
import { TestCaseRepository } from '@/domain/repositories/testCase/TestCaseRepository'
import { TestCase } from '@/domain/value_objects/testCase/TestCase'

interface JudgeCaseState {
  judgeCaseList: TestCase[]
  isLoading: boolean
  error: string | null
}

export const judgeCaseModule = (repository: TestCaseRepository): Module<JudgeCaseState, any> => {
  const getJudgeCaseListUseCase = new GetJudgeCaseListUseCase(repository)

  return {
    namespaced: true,
    state: {
      judgeCaseList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeCaseList(state, { judgeCaseList }: { judgeCaseList: TestCase[] }) {
        state.judgeCaseList = judgeCaseList
      },
      setIsLoading(state, { isLoading }: { isLoading: boolean }) {
        state.isLoading = isLoading
      },
      setError(state, { error }: { error: string | null }) {
        state.error = error
      }
    },
    actions: {
      async getJudgeCaseList({ commit }, { problemId }: { problemId: string }) {
        commit('setIsLoading', { isLoading: true })
        try {
          const res = await getJudgeCaseListUseCase.getJudgeCaseList(problemId)
          commit('setJudgeCaseList', { judgeCaseList: res })
        } catch (e) {
          commit('setError', { error: e })
        } finally {
          commit('setIsLoading', { isLoading: false })
        }
      }
    },
    getters: {
      judgeCaseList: state => state.judgeCaseList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
